import Index from "@/views/index/index.vue";
const routes = [
    {
        path: '/',
        redirect: '/index',
        meta: { title: "" },
		name: "home",
        children: [
            {
                // path: '/index', component: () => import('@/views/index/index.vue'),
				path: '/index', component: Index,
                meta: { title: "" },
            },
			{
				path: '/goods/index', component: () => import('@/views/goods/index.vue'),
				meta: { title: "GoodsList" },
			},
			{
				path: '/goods/view', component: () => import('@/views/goods/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/group/index', component: () => import('@/views/activity/group/index.vue'),
				meta: { title: "GroupList" },
			},
			{
				path: '/activity/group/view', component: () => import('@/views/activity/group/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/second/index', component: () => import('@/views/activity/second/index.vue'),
				meta: { title: "SecondList" },
			},
			{
				path: '/activity/second/view', component: () => import('@/views/activity/second/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/bargain/index', component: () => import('@/views/activity/bargain/index.vue'),
				meta: { title: "BargainList" },
			},
			{
				path: '/activity/bargain/view', component: () => import('@/views/activity/bargain/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/point/index', component: () => import('@/views/activity/point/index.vue'),
				meta: { title: "PointList" },
			},
			{
				path: '/activity/point/view', component: () => import('@/views/activity/point/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/activity/limit/index', component: () => import('@/views/activity/limit/index.vue'),
				meta: { title: "LimitList" },
			},
			{
				path: '/activity/limit/view', component: () => import('@/views/activity/limit/view.vue'),
				meta: { title: "" },
			},
			{
				path: '/user/register', component: () => import('@/views/user/register.vue'),
				meta: { title: "Register" },
			},
			{
				path: '/user/login', component: () => import('@/views/user/login.vue'),
				meta: { title: "Login" },
			},
			{
				path: '/user/forget', component: () => import('@/views/user/forget.vue'),
				meta: { title: "Forget" },
			},
			{
				path: '/user/bind', component: () => import('@/views/user/bind.vue'),
				meta: { title: "Bind" },
			},
			{
				path: '/search/index', component: () => import('@/views/search/index.vue'),
				meta: { title: "Search" },
			},
			{
				path: '/cart/index', component: () => import('@/views/cart/index.vue'),
				meta: { title: "Cart" },
			},
			{
				path: '/cart/confirm', component: () => import('@/views/cart/confirm.vue'),
				meta: { title: "Confirm" },
			},
			{
				path: '/cart/cashier', component: () => import('@/views/cart/cashier.vue'),
				meta: { title: "Cashier" },
			},
			{
				path: '/ucenter/index', component: () => import('@/views/ucenter/index.vue'),
				meta: { title: "UcenterIndex" },
			},
			{
				path: '/ucenter/order/index', component: () => import('@/views/ucenter/order/index.vue'),
				meta: { title: "MyOrder" },
			},
			{
				path: '/ucenter/order/detail', component: () => import('@/views/ucenter/order/detail.vue'),
				meta: { title: "OrderDetail" },
			},
			{
				path: '/ucenter/order/evaluate', component: () => import('@/views/ucenter/order/evaluate.vue'),
				meta: { title: "OrderEvaluate" },
			},
			{
				path: '/ucenter/order/refund', component: () => import('@/views/ucenter/order/refund.vue'),
				meta: { title: "OrderRefund" },
			},
			{
				path: '/ucenter/order/comment', component: () => import('@/views/ucenter/order/comment.vue'),
				meta: { title: "OrderComments" },
			},
			{
				path: '/ucenter/invoice/index', component: () => import('@/views/ucenter/invoice/index.vue'),
				meta: { title: "InvoiceIndex" },
			},
			{
				path: '/ucenter/address/index', component: () => import('@/views/ucenter/address/index.vue'),
				meta: { title: "Address" },
			},
			{
				path: '/ucenter/coupon/index', component: () => import('@/views/ucenter/coupon/index.vue'),
				meta: { title: "CouponIndex" },
			},
			{
				path: '/ucenter/recharge/index', component: () => import('@/views/ucenter/recharge/index.vue'),
				meta: { title: "RechargetIndex" },
			},
			{
				path: '/ucenter/wallet/index', component: () => import('@/views/ucenter/wallet/index.vue'),
				meta: { title: "MyWallet" },
			},
			{
				path: '/ucenter/visit/index', component: () => import('@/views/ucenter/visit/index.vue'),
				meta: { title: "MyVisit" },
			},
			{
				path: '/ucenter/collect/index', component: () => import('@/views/ucenter/collect/index.vue'),
				meta: { title: "MyCollect" },
			},
			{
				path: '/ucenter/user/password', component: () => import('@/views/ucenter/user/password.vue'),
				meta: { title: "ChangePassword" },
			},
			{
				path: '/page/view', component: () => import('@/views/page/view.vue'),
				meta: { title: "HelpCenter" },
			},
			{
				path: '/service/online', component: () => import('@/views/service/online.vue'),
				meta: { title: "OnlineCenter" },
			},
			{
				path: '/shop/index', component: () => import('@/views/shop/index.vue'),
				meta: { title: "ShopIndex" },
			}
        ],
    },
	{
	    path: '/404',
	    component: () => import('@/views/public/404.vue'),
		meta: { title: "" },
	    hidden: true
	},
    {
	    path: '/error',
	    component: () => import('@/views/public/error.vue'),
		meta: { title: "" },
	    hidden: true
	},
	{
	    path: '/webview/index',
	    component: () => import('@/views/webview/index.vue'),
		meta: { title: "" },
	    hidden: true
	},
	{ path: '/:pathMatch(.*)*', component: () => import('@/views/public/error.vue') }
];

export default routes
